import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import brandingService from "../../services/brandingService";

const useBrandingLogo = (reference?: string | null) =>
    useQuery([queryKeys.brandingLogo, reference], () => brandingService.fetchLogo(reference), {
        enabled: !!reference,
        staleTime: Infinity,
    });

export default useBrandingLogo;
